import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import BinaModal from '../../../ReactModal';

const ParamsModal = memo(({ residences, isOpen, hide }) => {
  const { t } = useTranslation();

  const {
    deadline,
    buildingClass,
    buildingsCount,
    blocks,
    apartmentsCount,
    liftsPerBlock,
    floorsPerBuilding,
    apartmentsPerFloor,
    technology,
    decoration,
    ceilingHeight,
    windowType,
    layout
  } = residences;

  return (
    <BinaModal
      isOpen={isOpen}
      onRequestClose={hide}
      modalId="params"
      overlayClassName="modal__overlay-params"
      contentClassName="modal__content-params"
    >
      <div className="params-modal">
        <div className="params-modal__title">
          {t('residences.params_modal_title')}
        </div>
        <span
          className="params-modal__close-btn"
          onClick={hide}
          onKeyPress={hide}
          role="button"
          tabIndex="-1"
        >
          ×
        </span>
        <div className="params-modal__content">
          <div className="params-modal__items-title">
            {t('residences.params_modal_content')}
          </div>
          <div className="params-modal__items">
            <ul className="params-modal__items-left">
              {deadline && <li>{t('residences.deadline')}</li>}
              {buildingClass && <li>{t('residences.class')}</li>}
              {buildingsCount && (
                <li>{t('residences.buildings_count_param')}</li>
              )}
              {blocks && <li>{t('residences.blocks_count')}</li>}
              {apartmentsCount && <li>{t('residences.apartments_count')}</li>}
              {liftsPerBlock && <li>{t('residences.lifts_per_block')}</li>}
              {floorsPerBuilding && (
                <li>{t('residences.floors_per_building')}</li>
              )}
              {apartmentsPerFloor && (
                <li>{t('residences.apartments_per_floor')}</li>
              )}
              {technology && <li>{t('residences.technology')}</li>}
              {decoration && <li>{t('residences.decoration')}</li>}
              {ceilingHeight && <li>{t('residences.ceiling_height')}</li>}
              {windowType && <li>{t('residences.window_type')}</li>}
              {layout && <li>{t('residences.layout')}</li>}
            </ul>
            <ul className="params-modal__items-right">
              {deadline && <li>{deadline}</li>}
              {buildingClass && <li>{buildingClass.name}</li>}
              {buildingsCount && <li>{buildingsCount}</li>}
              {blocks && <li>{blocks}</li>}
              {apartmentsCount && <li>{apartmentsCount}</li>}
              {liftsPerBlock && <li>{liftsPerBlock}</li>}
              {floorsPerBuilding && <li>{floorsPerBuilding}</li>}
              {apartmentsPerFloor && <li>{apartmentsPerFloor}</li>}
              {technology && <li>{technology.name}</li>}
              {decoration?.name && <li>{decoration?.name}</li>}
              {ceilingHeight && <li>{`${ceilingHeight} cm`}</li>}
              {windowType && <li>{windowType.name}</li>}
              {layout && <li>{layout.name}</li>}
            </ul>
          </div>
        </div>
        {residences.facilities?.length ? (
          <div className="params-modal__content-facilities">
            <div className="params-modal__items-title">
              {t('residences.facilities')}
            </div>
            <div className="params-modal__items">
              <ul className="params-modal__items-list">
                {residences.facilities?.map((item, index) => (
                  <li key={index} className="params-modal__items-facility-i">
                    <img src={item.iconUrl} alt="" />
                    <span>{item.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </BinaModal>
  );
});

ParamsModal.displayName = `ParamsModal`;

ParamsModal.propTypes = {
  isOpen: PropTypes.bool,
  apartment: PropTypes.object,
  hide: PropTypes.func,
  residences: PropTypes.object
};

export default ParamsModal;
